/*
 * Site-wide behavior. Loaded with defer from layout/theme.liquid.
 *  - Header gains its hairline after 24px of scroll (and while the phone menu is open).
 *  - Phone menu button opens/closes the nav panel (#site-nav[data-open]).
 *  - Scroll reveals: .reveal / .reveal-img get .is-in once 15% visible.
 *  - Bag count: dispatch `document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count } }))`
 *    after any cart change and every [data-cart-count] updates.
 */
(() => {
  const header = document.getElementById('site-header');
  const toggle = document.getElementById('menu-toggle');
  const nav = document.getElementById('site-nav');

  if (header) {
    const onScroll = () =>
      header.toggleAttribute('data-scrolled', window.scrollY > 24 || (nav && nav.hasAttribute('data-open')));
    onScroll();
    addEventListener('scroll', onScroll, { passive: true });

    if (toggle && nav) {
      const setOpen = (open) => {
        nav.toggleAttribute('data-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        onScroll();
      };
      toggle.addEventListener('click', () => setOpen(!nav.hasAttribute('data-open')));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && nav.hasAttribute('data-open')) {
          setOpen(false);
          toggle.focus();
        }
      });
      matchMedia('(min-width: 64rem)').addEventListener('change', (e) => e.matches && setOpen(false));
    }
  }

  const els = document.querySelectorAll('.reveal, .reveal-img');
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.15, rootMargin: '0px 0px -5% 0px' },
    );
    els.forEach((el) => io.observe(el));
  } else {
    els.forEach((el) => el.classList.add('is-in'));
  }

  document.addEventListener('cart:updated', (e) => {
    const count = e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
    if (count === null) return;
    document.querySelectorAll('[data-cart-count]').forEach((el) => (el.textContent = String(count)));
  });
})();
